import { EXECUTION_STATUS } from 'personalization-lib/constants/suggestions';
export const isInProgress = status => status === EXECUTION_STATUS.IN_PROGRESS;
export const isFailed = status => status === EXECUTION_STATUS.FAILED;